import React from "react";

export const ComponentNotFoundInCMS = ({ message }: { message: string }) => {
  return (
    <div className="flex h-[300px] w-screen items-center justify-center">
      <h1>{message} </h1>
    </div>
  );
};
